import { ConfigDialog_SmartDocs_NoteIds } from './ConfigDialog_SmartDocs_NoteIds/ConfigDialog_SmartDocs_NoteIds.js';
import { ConfigKey_SmartDocs_NoteIds } from '@app/advisor-content-shared';
export const ConfigDialogKeys_AdvisorContent = [ConfigKey_SmartDocs_NoteIds];
export const ConfigDialogs_AdvisorContent_Labels = {
    [ConfigKey_SmartDocs_NoteIds]: 'Note IDs',
};
export const ConfigDialogs_AdvisorContent_Dialogs = {
    [ConfigKey_SmartDocs_NoteIds]: ConfigDialog_SmartDocs_NoteIds,
};
//# sourceMappingURL=index.js.map